export default "__VITE_ASSET__Dc_6EU9e__"